import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const GET_NASJONER_URL = `${ILEGGELSE_SERVICE_BASE_URL}/nasjoner`;
export const POST_NASJON_URL = `${ILEGGELSE_SERVICE_BASE_URL}/nasjoner`;
export const PUT_NASJON_URL = (id) =>
  `${ILEGGELSE_SERVICE_BASE_URL}/nasjoner/${id}`;
